<template>
  <div>
    <b-card>
      <div
        class="table-header-border-bottom pb-1 mb-md-3 d-flex justify-content-between align-items-center"
      >
        <h3 class="mt-1 d-flex align-items-center">
          <feather-icon
            icon="CheckSquareIcon"
            class="mr-50"
            style="width: 18px; height: 18px"
          />
          <span>Checkouts</span>
        </h3>
        <!-- <div class="d-flex">
          <b-button
            class="gradient-btn mt-1"
            :to="{ name: 'financial-checkouts-account' }"
          >
            Checkout
          </b-button>
        </div> -->
      </div>
      <b-form
        @submit.prevent="filter"
        class="filters rounded p-1 my-md-1 d-flex align-items-center justify-content-between flex-wrap"
      >
        <div class="col-sm-3 col-12 p-50 d-flex align-items-center">
          <!-- <div class="mr-50">
            <b-form-checkbox v-model="selectAll"></b-form-checkbox>
          </div> -->
          <v-select
            :options="types"
            v-model="type"
            label="label"
            :reduce="(option) => option.value"
            :searchable="false"
            placeholder="Display on the page"
            class="w-100"
          ></v-select>
        </div>

        <div class="col-sm-6 col-12 d-flex align-items-center flex-wrap p-50">
          <template v-if="type == 'payable'">
            <div class="col-md-6 col-12 py-50 px-sm-50 px-0">
              <select-box
                v-model="payable_type"
                class="w-100"
                searchable
                :lists="['user', 'partner', 'competition', 'plan']"
              />
            </div>
            <div class="col-md-6 col-12 py-50 px-sm-50 px-0">
              <select-box
                v-model="payable_id"
                label="text"
                class="w-100"
                select="id"
                searchable
                :url="payable_type"
              />
            </div>
          </template>

          <b-form-input
            v-else
            placeholder="search"
            v-model.trim="search"
            :disabled="!type"
          />
        </div>
        <div class="col-sm-3 col-12 p-50">
          <b-button
            class="w-100"
            type="submit"
            :disabled="!search && !(!search && payable_type && payable_id)"
          >
            <span class="text-muted h5"> Filtering</span>
          </b-button>
        </div>
      </b-form>
      <data-table :fields="fields" :items="checkouts" :loading="loading">
        <template #id="{ data }">
          <div class="d-flex">
            <div class="pr-50 border-right mr-75">
              <span class="font-weight-bold h5 mb-0">{{ data.item.id }}</span>
            </div>
          </div>
        </template>
        <template #bank_account="{ data }">
          <span class="nowrap-white-space">
            {{ data.item.bank_account.account_name }}
          </span>
        </template>

        <template #amount="{ data }">
          <span class="mb-0" style="white-space: nowrap">
            {{
              data.item.amount
                ? `$ ${
                    0 > data.item.amount
                      ? Math.abs(data.item.amount).toFixed(2)
                      : data.item.amount
                  } `
                : "-"
            }}
          </span>
        </template>
        <template #payable="{ data }">
          <span style="white-space: nowrap">
            {{ data.item.payable.data.owner_type }}

            {{
              hasOwnNestedProperty(data.item, "payable.data.first_name")
                ? data.item.bank_account.owner_type +
                  " - " +
                  data.item.payable.data.first_name +
                  " " +
                  data.item.payable.data.last_name
                : hasOwnNestedProperty(data.item, "payable.data.name")
                ? data.item.bank_account.owner_type +
                  " - " +
                  data.item.payable.data.name
                : "-"
            }}
          </span>
        </template>
        <template #status="{ data }">
          {{ data.item.wallet.data.holder.status }}
        </template>
        <template #wallet_address="{ data }">
          {{ data.item.bank_account.wallet_address }}
        </template>
        <template #currency_name="{ data }">
          {{ data.item.bank_account.currency_name }}
        </template>
        <template #description="{ data }">
          {{ data.item.description || "-" }}
        </template>
        <template #time="{ data }">
          <div class="  ">
            <div class="text-red" cols="12" style="white-space: nowrap">
              created at
              {{
                data.item.bank_account.created_at
                  ? changeformatTime(data.item.bank_account.created_at)
                  : "-"
              }}
            </div>
            <div class="text-green" cols="12" style="white-space: nowrap">
              updated at
              {{
                data.item.bank_account.updated_at
                  ? changeformatTime(data.item.bank_account.updated_at)
                  : "-"
              }}
            </div>
          </div>
        </template>
        <template #actions="{ data }">
          <div class="nowrap-white-space">
            <b-dropdown no-caret class="d-flex d-xl-none more-option">
              <template #button-content>
                <feather-icon icon="MoreVerticalIcon" />
              </template>
              <b-dropdown-item
                variant="flat-primary"
                class="mx-25"
                @click="
                  showChangeStatus = true;
                  currentData = data.item;
                "
              >
                <div class="d-flex align-items-center w-100">
                  <feather-icon icon="EditIcon" class="mr-50" />Change status
                </div>
              </b-dropdown-item>
            </b-dropdown>
            <div class="d-xl-flex d-none">
              <b-button
                variant="flat-primary"
                class="mx-25"
                @click="
                  showChangeStatus = true;
                  currentData = data.item;
                "
                ><feather-icon icon="EditIcon" />Change status</b-button
              >
            </div>
          </div>
        </template>
      </data-table>

      <div
        class="w-100 d-flex flex-wrap align-items-center justify-content-between"
      >
        <b-pagination
          v-model="currentPage"
          :total-rows="pagination.total"
          :per-page="pagination.per_page"
          size="lg"
          pills
          class="my-2 d-flex justify-content-center"
        >
        </b-pagination>
      </div>
      <checkouts-change-status-modal
        :showChangeStatus="showChangeStatus"
        v-model="showChangeStatus"
        :currentData="currentData"
        @updateCheckouts="getCheckouts"
      />
    </b-card>
  </div>
</template>
<script>
import {
  BButton,
  BModal,
  VBModal,
  BPagination,
  BLink,
  BCard,
  BFormCheckbox,
  BForm,
  BFormInput,
  BBadge,
  VBTooltip,
  BDropdown,
  BDropdownItem,
} from "bootstrap-vue";
import DataTable from "@/@core/components/data-table/DataTable.vue";
import qs from "qs";
import VSelect from "vue-select";
import SelectBox from "@core/components/select-box/SelectBox.vue";
import CheckoutsChangeStatusModal from "./checkouts-change-status-modal/CheckoutsChangeStatusModal.vue";
let moment = require("jalali-moment");
export default {
  components: {
    DataTable,
    BButton,
    BModal,
    BCard,
    VBModal,
    BPagination,
    BLink,
    BFormCheckbox,
    BForm,
    BFormInput,
    BBadge,
    VSelect,
    CheckoutsChangeStatusModal,
    SelectBox,
    BDropdown,
    BDropdownItem,
  },
  data() {
    return {
      url: "/panel/checkouts",
      currentPage: 1,
      loading: false,
      pagination: {},
      pages: [],
      showChangeStatus: false,
      currentData: {},
      selectedPage: "",
      types: [
        // { label: "Amount", value: "amount" },   * ERR 500
        { label: "Status", value: "status" },
        // { label: "Payable", value: "payable" },
      ],
      type: "",
      search: "",
      payable_type: "",
      payable_id: "",
      fields: [
        { key: "id", label: "row" },
        { key: "bank_account", label: " account name" },
        { key: "payable", label: "user name" },
        { key: "status", label: "status" },
        { key: "wallet_address", label: "wallet address" },
        { key: "currency_name", label: "currency name" },
        { key: "description", label: "description" },
        { key: "amount", label: "amount" },
        { key: "time", label: "time" },
        { key: "actions", label: "operation" },
      ],
      checkouts: [],
    };
  },
  directives: {
    "b-modal": VBModal,
    "b-tooltip": VBTooltip,
  },
  watch: {
    async type(val) {
      this.search = await "";
      this.payable_type = await "";
      this.payable_id = await "";
      if (this.$route.fullPath != "/financial/checkouts") {
        this.$router.push({
          name: "financial-checkouts",
        });
      }
    },
    currentPage(val) {
      if (val != this.$route.query.page) {
        this.$router.push({
          name: "financial-checkouts",
          query: {
            ...this.$route.query,
            page: val,
          },
        });
      }
    },
    $route: {
      handler(val) {
        this.getCheckouts();
      },
      immediate: true,
      deep: true,
    },
    search(val) {
      if (!val) {
        if (this.$route.query.filter) {
          let filter = {};
          this.$router.push({
            name: "financial-checkouts",
            query: {
              filter,
            },
          });
        }
      }
    },
  },
  created() {
    if (this.$route.query.filter) {
      this.$router.push({
        name: "financial-checkouts",
        query: {},
      });
    }
  },
  methods: {
    filter() {
      if (this.type) {
        let filter = {};
        if (this.type == "payable") {
          filter = {
            payable: {
              type: this.payable_type,
              id: this.payable_id,
            },
          };
        } else {
          filter[this.type] =
            this.type == "status" ? this.search.toUpperCase() : this.search;
        }
        this.$router.push({
          name: "financial-checkouts",
          query: {
            ...this.$route.query,
            filter,
          },
        });
      } else if (this.$route.fullPath != "/financial/checkouts") {
        this.$router.push({
          name: "financial-checkouts",
        });
      }
    },
    async getCheckouts() {
      this.showChangeStatus = false;
      this.loading = true;
      try {
        const params = {
          per_page: 8,
          ...this.$route.query,
        };
        const { data } = await this.$http.get("/panel/checkouts", {
          params,
          paramsSerializer: (params) => {
            return qs.stringify(params);
          },
        });
        this.checkouts = data.data;
        this.pagination = await data.meta.pagination;
        this.currentPage = await this.pagination.current_page;
      } catch (err) {}
      this.loading = false;
    },
    changeformatTime(time) {
      return moment(time).format("YY-MM-DD");
    },
  },
};
</script>
